import request from '@/utils/request';
export function messageList(data) {
  return request.post('admin/note/list', data);
}
export function addMessage(data) {
  return request.post('admin/note/store', data);
}
export function editMessage(data) {
  return request.post('admin/note/edit', data);
}